import { render, staticRenderFns } from "./addSecKillPage.vue?vue&type=template&id=4ff1e9c6&scoped=true"
import script from "./addSecKillPage.vue?vue&type=script&lang=js"
export * from "./addSecKillPage.vue?vue&type=script&lang=js"
import style0 from "./addSecKillPage.vue?vue&type=style&index=0&id=4ff1e9c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1e9c6",
  null
  
)

component.options.__file = "addSecKillPage.vue"
export default component.exports